var _circle, _circle2, _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1503_600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1503_600)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1503_600)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 95,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 92,
    width: 120,
    height: 40,
    fill: "#E0F5F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1503_600)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 96,
    height: 22,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 4,
    height: 60,
    fill: "#008B6D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 24,
    width: 2,
    height: 44,
    fill: "#008B6D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 76,
    width: 2,
    height: 8,
    fill: "#008B6D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 24,
    width: 4,
    height: 60,
    fill: "#008B6D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 64,
    height: 4,
    fill: "#008B6D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 80,
    width: 64,
    height: 4,
    fill: "#008B6D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 53,
    width: 4,
    height: 2,
    fill: "#008B6D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 53,
    width: 18,
    height: 2,
    fill: "#008B6D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1503_600",
    x: 5,
    y: 25,
    width: 110,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1503_600"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1503_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1503_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1503_600",
    x: 5,
    y: 3,
    width: 110,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1503_600"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1503_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1503_600",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.e311f88a60d5ae3e87e20238aedeec0c.svg";
export { ForwardRef as ReactComponent };